import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { Doctor } from '@magnetar/data-access'

interface DoctorResponse {
  success: boolean
  data: Doctor | null
  error?: {
    code: string
    message: string
  }
}

// 醫生學經歷項目（JSON 欄位，每筆包含學校與年份）
interface DoctorEducationItem {
  school?: string
  year?: string
}

interface CreateDoctorRequest {
  clinic_id: number
  name: string
  specialty: string[]
  experience: string[]
  education?: DoctorEducationItem[]
  profile_image?: string
  description?: string
}

interface UpdateDoctorRequest {
  name?: string
  specialty?: string[]
  experience?: string[]
  education?: DoctorEducationItem[]
  profile_image?: string
  description?: string
  is_active?: boolean
}

export const doctorService = {
  createDoctor: async (data: CreateDoctorRequest, token: string): Promise<DoctorResponse> => {
    try {
      const response = await apiClient.post<DoctorResponse>('/api/doctor', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as DoctorResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'CREATE_DOCTOR_FAILED',
          message: '新增醫生失敗',
        },
      }
    }
  },

  updateDoctor: async (
    id: number,
    data: UpdateDoctorRequest,
    token: string,
  ): Promise<DoctorResponse> => {
    try {
      const response = await apiClient.put<DoctorResponse>(`/api/doctor/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as DoctorResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'UPDATE_DOCTOR_FAILED',
          message: '更新醫生資訊失敗',
        },
      }
    }
  },

  deleteDoctor: async (id: number, token: string): Promise<DoctorResponse> => {
    try {
      const response = await apiClient.delete<DoctorResponse>(`/api/doctor/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as DoctorResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'DELETE_DOCTOR_FAILED',
          message: '刪除醫生失敗',
        },
      }
    }
  },

  hardDeleteDoctor: async (id: number, token: string): Promise<DoctorResponse> => {
    try {
      const response = await apiClient.delete<DoctorResponse>(`/api/doctor/${id}/hard`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as DoctorResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'HARD_DELETE_DOCTOR_FAILED',
          message: '硬刪除醫生失敗',
        },
      }
    }
  },
}
